/**
 * Sin sugerencias del navegador («información guardada», autocompletar) en los campos del panel:
 * los datos de clientes, productos o pedidos no deben llenarse con lo que el navegador recuerda de
 * otros formularios. Un campo que declare su propio `autocomplete` (correo y contraseñas al
 * ingresar, códigos de verificación) lo conserva.
 */
const FIELDS = 'input:not([autocomplete]), textarea:not([autocomplete])';
const SKIP = new Set(['checkbox', 'radio', 'file', 'color', 'range', 'hidden', 'submit', 'button']);

function apply(root: ParentNode) {
  for (const field of root.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(FIELDS)) {
    if (field instanceof HTMLInputElement && SKIP.has(field.type)) continue;
    field.setAttribute('autocomplete', 'off');
  }
}

export function installNoAutofill(doc: Document = document): () => void {
  apply(doc);
  // Los campos aparecen al navegar o abrir ventanas: se marcan apenas entran al documento.
  const observer = new MutationObserver((records) => {
    for (const record of records)
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches(FIELDS)) apply(node.parentElement ?? doc);
        else apply(node);
      }
  });
  observer.observe(doc.documentElement, { childList: true, subtree: true });
  return () => observer.disconnect();
}
